// Prioritized markets for Apocalypz.org. Rates are approximate USD conversions
// for DISPLAY ONLY — checkout is always processed in USD.
export const REGIONS = [
  { code: "NG", label: "Nigeria", flag: "🇳🇬", country: "Nigeria", currency: "NGN", symbol: "₦", rate: 1550 },
  { code: "GH", label: "Ghana", flag: "🇬🇭", country: "Ghana", currency: "GHS", symbol: "GH₵", rate: 15 },
  { code: "ZA", label: "South Africa", flag: "🇿🇦", country: "South Africa", currency: "ZAR", symbol: "R", rate: 18.5 },
  { code: "JM", label: "Jamaica / Caribbean", flag: "🇯🇲", country: "Jamaica", currency: "JMD", symbol: "J$", rate: 157 },
  { code: "GB", label: "United Kingdom", flag: "🇬🇧", country: "United Kingdom", currency: "GBP", symbol: "£", rate: 0.79 },
  { code: "BR", label: "Brazil", flag: "🇧🇷", country: "Brazil", currency: "BRL", symbol: "R$", rate: 5.4 },
  { code: "KE", label: "Kenya", flag: "🇰🇪", country: "Kenya", currency: "KES", symbol: "KSh", rate: 129 },
  { code: "US", label: "United States", flag: "🇺🇸", country: "United States", currency: "USD", symbol: "$", rate: 1 },
  { code: "GLOBAL", label: "Global", flag: "🌍", country: "", currency: "USD", symbol: "$", rate: 1 },
];

const CARIBBEAN = ["JM", "TT", "BB", "BS", "GD", "LC", "VC", "DM", "AG", "KN", "HT", "GY", "SR", "BZ", "PR", "CU", "DO"];

export function regionByCode(code) {
  return REGIONS.find((r) => r.code === code) || REGIONS.find((r) => r.code === "GLOBAL");
}

export function countryCodeToRegion(cc) {
  if (!cc) return "GLOBAL";
  cc = cc.toUpperCase();
  if (CARIBBEAN.includes(cc)) return "JM";
  const direct = REGIONS.find((r) => r.code === cc);
  return direct ? direct.code : "GLOBAL";
}

export function formatPrice(usd, region) {
  const r = region || regionByCode("GLOBAL");
  if (r.currency === "USD") return `$${Number(usd).toFixed(2)}`;
  const converted = Number(usd) * r.rate;
  const rounded = converted >= 100 ? Math.round(converted) : Math.round(converted * 100) / 100;
  const str = rounded.toLocaleString("en-US", { maximumFractionDigits: rounded >= 100 ? 0 : 2 });
  return `${r.symbol}${str}`;
}
